// extracted by mini-css-extract-plugin
module.exports = {"seat":"seat--seat--1PiV7a2","arrow":"seat--arrow--3ysykm0","title":"seat--title--aW17uLV","desc":"seat--desc--1Ia5PYp","link":"seat--link--3wADPOA"};